import { css } from "lit";

export const holidaysCalendarStyles = css`
    :host {
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        background-color: white;
    }

    .vc {
        position: relative;
    }

    .year-controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }

    .arrow {
        cursor: pointer;
    }

    .arrow svg {
        width: 12px;
        height: 12px;
    }

    .arrow.right svg {
        transform: rotate(180deg);
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;
    }
`;
